export default __webpack_public_path__ + "static/rich-e63c90f0a9c8c2bd72a263cf404dad38.mp4";